import { Component, Input, OnInit } from "@angular/core";
import moment from "moment";
import { AppService } from "src/app/core/services/app.service";
import { CustomerService } from "src/app/core/services/customer.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { CheckDto } from "src/app/shared/models/check-dto";

@Component({
	selector: "app-customer-visit-detail",
	templateUrl: "./customer-visit-detail.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class CustomerVisitDetailComponent implements OnInit {
	@Input() view: string;
	checkSelected: CheckDto;

	moment: any = moment;

	constructor(public app: AppService, private focuslink: FocuslinkService, public customerService: CustomerService) {}

	ngOnInit(): void {}

	async viewCheck(checkKey: string) {
		const resp = await this.focuslink.getCheck(this.customerService.venueService.venueKey, checkKey);
		this.checkSelected = new CheckDto(resp);
	}
}
